module.exports = __webpack_public_path__ + "img/chordMate.f1f59966.png";